import * as abnTesting from './abnTesting';
import * as account from './account';
import * as accountStatus from './accountStatus';
import * as acquisitionAnalytics from './acquisitionAnalytics';
import * as adminContentSeries from './adminContentSeries';
import * as analytics from './analytics';
import * as announcements from './announcements';
import * as articles from './articles';
import * as artist from './artist';
import * as auth from './auth';
import * as brandKit from './brandKit';
import * as books from './books';
import * as chapters from './books/chapters';
import * as calendar from './calendar';
import * as catalogs from './catalogs';
import * as chatbot from './chatbot';
import * as chatbotPrompts from './chatbotPrompts';
import * as chats from './chats';
import * as clips from './clips';
import * as comments from './comments';
import * as content from './content';
import * as contentArticle from './contentArticle';
import * as contentCategories from './contentCategories';
import * as contentMedia from './contentMedia';
import * as contentSeries from './contentSeries';
import * as contentSeriesTranslation from './contentSeriesTranslation';
import * as contentStudyGuide from './contentStudyGuide';
import * as contentTags from './contentTags';
import * as contentTranscripts from './contentTranscripts';
import * as contentTranslation from './contentTranslation';
import * as conversations from './conversations';
import * as courses from './courses';
import * as coverArts from './coverArts';
import * as credits from './credits';
import * as crmAnalytics from './crmAnalytics';
import * as dailyItemLocales from './dailyItemLocales';
import * as dailyItems from './dailyItems';
import * as dailySeries from './dailySeries';
import * as dashboardAccounts from './dashboardAccounts';
import * as dolly from './dolly';
import * as donationFunds from './donationFunds';
import * as donations from './donations';
import * as emailCampaigns from './emailCampaigns';
import * as emailHealth from './emailHealth';
import * as emails from './emails';
import * as emailTemplates from './emailTemplates';
import * as experiments from './experiments';
import * as externalMetadata from './externalMetadata';
import * as featureFlags from './featureFlags';
import * as followers from './followers';
import * as givingAccounts from './givingAccounts';
import * as givingPayments from './givingPayments';
import * as home from './home';
import * as imageAI from './imageAI';
import * as impressionAnalytics from './impressionAnalytics';
import * as integrations from './integrations';
import * as leadCampaigns from './leadCampaigns';
import * as leadClients from './leadClients';
import * as leadSegments from './leadSegments';
import * as leadsLists from './leadsLists';
import * as locales from './locales';
import * as marketingCampaigns from './marketingCampaigns';
import * as mediaAssets from './mediaAssets';
import * as members from './members';
import * as nameCapture from './nameCapture';
import * as offers from './offers';
import * as organizations from './organizations';
import * as periodicTable from './periodicTable';
import * as plgSetupIntent from './plgSetupIntent';
import * as prayRadioSchedule from './prayRadioSchedule';
import * as prayTvSchedule from './prayTvSchedule';
import * as productMetrics from './productMetrics';
import * as products from './products';
import * as productsSubscriptions from './productsSubscriptions';
import * as purchases from './purchases';
import * as promoUnit from './promoUnit';
import * as pushCampaigns from './pushCampaigns';
import * as queues from './queues';
import * as recurringCampaigns from './recurringCampaigns';
import * as recurringPushCampaigns from './recurringPushCampaigns';
import * as renewalAnalytics from './renewalAnalytics';
import * as reports from './reports';
import * as rssFeed from './rssFeed';
import * as seedEmails from './seedEmails';
import * as segmentation from './segmentation';
import * as segments from './segments';
import * as seriesTags from './seriesTags';
import * as sms from './sms';
import * as socialClips from './socialClips';
import * as socialPosts from './socialPosts';
import * as socials from './socials';
import * as studioNotifications from './studioNotifications';
import * as superfunnel from './superfunnel';
import * as superfunnelWeeklyReport from './superfunnelWeeklyReport';
import * as systemCheck from './systemCheck';
import * as tag from './tag';
import * as taggings from './taggings';
import * as tagLocales from './tagLocales';
import * as team from './team';
import * as testimonials from './testimonials';
import * as tokens from './tokens';
import * as transcripts from './transcripts';
import * as transcriptionSettings from './transcriptionSettings';
import * as translations from './translations';
import * as unsubs from './unsubs';
import * as voices from './voices';
import * as warmupCampaigns from './warmupCampaigns';
import * as workflowAI from './workflowAI';
import * as workflowAutomations from './workflowAutomations';

export default {
  abnTesting,
  account,
  acquisitionAnalytics,
  adminContentSeries,
  analytics,
  announcements,
  articles,
  accountStatus,
  artist,
  brandKit,
  auth,
  calendar,
  catalogs,
  chatbot,
  chatbotPrompts,
  chats,
  clips,
  comments,
  content,
  contentCategories,
  contentMedia,
  contentArticle,
  contentSeries,
  contentSeriesTranslation,
  contentStudyGuide,
  contentTags,
  contentTranscripts,
  contentTranslation,
  conversations,
  courses,
  coverArts,
  credits,
  crmAnalytics,
  dashboardAccounts,
  dailyItemLocales,
  dailyItems,
  dailySeries,
  dolly,
  donationFunds,
  donations,
  emailCampaigns,
  emails,
  leadSegments,
  leadsLists,
  emailTemplates,
  experiments,
  externalMetadata,
  featureFlags,
  followers,
  givingAccounts,
  givingPayments,
  home,
  imageAI,
  impressionAnalytics,
  integrations,
  leadCampaigns,
  leadClients,
  marketingCampaigns,
  mediaAssets,
  locales,
  offers,
  members,
  nameCapture,
  organizations,
  periodicTable,
  productMetrics,
  products,
  productsSubscriptions,
  purchases,
  prayRadioSchedule,
  prayTvSchedule,
  plgSetupIntent,
  promoUnit,
  pushCampaigns,
  queues,
  recurringCampaigns,
  recurringPushCampaigns,
  renewalAnalytics,
  reports,
  rssFeed,
  seedEmails,
  segmentation,
  segments,
  seriesTags,
  sms,
  socialClips,
  socialPosts,
  tag,
  taggings,
  tagLocales,
  team,
  testimonials,
  tokens,
  transcripts,
  transcriptionSettings,
  unsubs,
  warmupCampaigns,
  workflowAI,
  workflowAutomations,
  voices,
  socials,
  studioNotifications,
  superfunnel,
  superfunnelWeeklyReport,
  systemCheck,
  emailHealth,
  translations,
  books,
  chapters,
};
